import { ComponentType, SVGProps } from "react"

const TONES = {
  green: "bg-vm-green-soft text-vm-green-text",
  primary: "bg-vm-primary-soft text-vm-primary-text",
  red: "bg-vm-red-soft text-vm-red-text",
  yellow: "bg-vm-yellow-soft text-vm-yellow-text",
} as const

/** Large round icon heading a confirmation or error state. */
export default function StatusIcon({
  icon: Icon,
  tone,
}: {
  icon: ComponentType<SVGProps<SVGSVGElement>>
  tone: keyof typeof TONES
}) {
  return (
    <div
      className={`mx-auto flex h-16 w-16 animate-scale-in items-center justify-center rounded-full ${TONES[tone]}`}
    >
      <Icon aria-hidden="true" className="h-8 w-8" />
    </div>
  )
}
